// API 서버 URL 설정
//
// 값이 비어 있으면 상대 경로(same-origin)로 호출한다.
// 백엔드를 같은 도메인의 리버스 프록시로 붙인 경우 이게 정상 동작이다.
//
// 값을 지정하려면:
//   - 로컬 개발 : frontend/.env.development 의 REACT_APP_API_BASE_URL
//   - 운영 빌드 : frontend/.env.production 또는 빌드 시 환경변수 주입
export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').trim();

if (!API_BASE_URL) {
    console.warn(
        'REACT_APP_API_BASE_URL이 설정되지 않아 API를 상대 경로(same-origin)로 호출합니다. ' +
        '백엔드가 다른 도메인에 있다면 .env.production 에 주소를 설정한 뒤 다시 빌드하세요.'
    );
}

export default API_BASE_URL;
